// extracted by mini-css-extract-plugin
var _1 = "styles-module__link___Li0hN";
export { _1 as "link" }
